<template>
  <GridRow v-if="videoIds.length > 0">
    <GridColumn
      v-for="videoId in videoIds"
      :key="videoId"
      :md="hasSingleVideo ? 12 : 6"
    >
      <YoutubeVideo :video-id="videoId" />
    </GridColumn>
  </GridRow>
</template>

<script lang="ts" setup>
import { computed, type PropType } from 'vue';
import { extractYoutubeId } from '@i22/rocket';
import { GridColumn, GridRow, YoutubeVideo } from '@i22/td-longtail-vue-components';
import type { Attachment } from '~/lib/goliath/goliath.types';

const props = defineProps({
  media: {
    type: Array as PropType<Attachment[]>,
    required: true,
  },
});

const videoIds = computed(
  () =>
    props.media
      ?.map((mediaObject) => {
        if (mediaObject.type !== 'VIDEO' || !mediaObject.remote || !mediaObject.url) return false;
        try {
          return extractYoutubeId(mediaObject.url);
        } catch (e) {
          return false;
        }
      })
      .filter(Boolean) || []
);
const hasSingleVideo = computed(() => videoIds.value.length === 1);
</script>
